import { translatingStatusAtom } from 'articleEditor/hooks/translations/useBaseTranslation';
import { useAtomValue } from 'jotai';
import { TranslatingType } from 'lib-knowledge-remote-types/general.types';

export const useIsTranslating = (): boolean => {
  const translatingStatus = useAtomValue(translatingStatusAtom);
  return translatingStatus.type !== TranslatingType.NONE;
};
